module.exports = __webpack_public_path__ + "img/Edit-Pen.c1cda583.svg";